import { Stack, SxProps, Typography } from '@mui/material';
import { Loading } from 'components/Loading';

type Props = {
  title?: string;
  stackSx?: SxProps;
};

export const LoadingIndicator: React.FC<Props> = ({ title, stackSx }) => {
  return (
    <Stack spacing="20px" alignItems="center" sx={stackSx}>
      <Loading size="64px" />
      {title && (
        <Typography
          color="primary"
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px'
          }}
        >
          {title}
        </Typography>
      )}
    </Stack>
  );
};
